export default {"src":"/_next/static/media/search-page-fallback-img.dff07fe5.svg","height":197,"width":201,"blurWidth":0,"blurHeight":0};